import type { CampaignInfluencer } from "@/marketing/models/campaignInfluencer";
import {
  STANDARD_PIPELINE_DEFINITION,
  type CampaignPipelineDefinition,
} from "@/marketing/models/campaignPipeline";
import { downloadCsv, generateCampaignInfluencerCsv } from "@/marketing/lib/csvExport";

// en-CA renders dates as YYYY-MM-DD in the user's local timezone.
const CSV_FILENAME_DATE_LOCALE = "en-CA";

export function buildColumnCsvFilename(label: string, isoDate: string): string {
  const slug = label
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  return `campaign-${slug}-${isoDate}.csv`;
}

export function downloadColumnCsv(
  label: string,
  creators: CampaignInfluencer[],
  tagNameById: Map<string, string> = new Map(),
  pipelineDefinition: CampaignPipelineDefinition = STANDARD_PIPELINE_DEFINITION,
): void {
  const csv = generateCampaignInfluencerCsv(
    creators,
    tagNameById,
    undefined,
    "ready",
    pipelineDefinition,
  );
  const date = new Intl.DateTimeFormat(CSV_FILENAME_DATE_LOCALE).format(new Date());
  downloadCsv(csv, buildColumnCsvFilename(label, date));
}
